import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// comentario.service.js — Chat de comentários nas tarefas (r35 item 6)
// ════════════════════════════════════════════════════════════════════════════

const comentarioService = {

  // Lista comentários de uma tarefa (em ordem cronológica)
  listar: async (tarefaId) => {
    const res = await api.get(`/tarefas/${tarefaId}/comentarios`);
    return res.data;
  },

  // Cria comentário. `anexos` é array vindo de uploads prévios:
  //   [{ caminho, nome_original, tamanho_bytes, mime, inline }]
  criar: async (tarefaId, { corpo, usuario_id, anexos, parent_id }) => {
    const res = await api.post(`/tarefas/${tarefaId}/comentarios`,
      { corpo, usuario_id, anexos: anexos || [], parent_id: parent_id || null });
    return res.data;
  },

  // Edita corpo do comentário (só autor)
  editar: async (comentarioId, { corpo, usuario_id }) => {
    const res = await api.put(`/comentarios/${comentarioId}`, { corpo, usuario_id });
    return res.data;
  },

  // Deleta comentário (só autor)
  deletar: async (comentarioId, usuario_id) => {
    const res = await api.delete(`/comentarios/${comentarioId}`,
      { data: { usuario_id } });
    return res.data;
  },

  // Upload de arquivo (multipart). Retorna { nome_original, caminho, tamanho_bytes, mime }
  upload: async (tarefaId, file) => {
    const form = new FormData();
    form.append('arquivo', file);
    const res = await api.post(`/tarefas/${tarefaId}/comentarios/upload`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

};

export default comentarioService;
